import type { TrainMode } from "./session.ts";
import { reviewTimeLabel } from "./reviewQueue.ts";

export type PracticeCopy = {
  mode: TrainMode;
  title: string;
  sentence: string;
};

export const PRACTICES: readonly PracticeCopy[] = [
  {
    mode: "learn",
    title: "Main line",
    sentence: "Follow the course with coaching and its main-line replies.",
  },
  {
    mode: "recall",
    title: "From memory",
    sentence: "Recall a short stretch with the move hidden, then revisit difficult decisions.",
  },
  {
    mode: "branches",
    title: "Side lines",
    sentence: "Meet a named reply. The idea is shown the first time; the move stays hidden.",
  },
  {
    mode: "review",
    title: "Repeat positions",
    sentence: "A short mixed set of due positions, with feedback and a chance to repair misses.",
  },
];

export const EMPTY_REVIEW_MESSAGE =
  "Nothing is due right now. Practise a recent position or recall a short line.";

/** Shown when this sitting has nothing due but some positions return within a day. */
export function emptyReviewMessage(soon: number, nextDue?: number | null): string {
  if (nextDue)
    return `Nothing is due right now. Your next position returns ${reviewTimeLabel(nextDue)}.`;
  if (soon > 0) {
    const noun = soon === 1 ? "position comes" : "positions come";
    return `${soon} ${noun} back soon. Nothing is due right now.`;
  }
  return EMPTY_REVIEW_MESSAGE;
}

export const REVIEW_GRADE_LINE = "Take your time. Feedback stays on this board until you continue.";

export function practiceByMode(mode: TrainMode): PracticeCopy {
  return PRACTICES.find((practice) => practice.mode === mode) ?? PRACTICES[0];
}

export function practiceSentence(practice: PracticeCopy, side: "white" | "black"): string {
  return side === "black" && practice.mode === "branches"
    ? "Meet a named White reply. The idea is shown the first time; the move stays hidden."
    : practice.sentence;
}
